import { useAuth } from '@/app/hooks/useAuth'
import { WithdrawService } from '@/app/services/WithdrawService'
import { useToast } from '@/view/components/ui/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

export const useErrorWithdrawModalController = () => {
  const queryClient = useQueryClient()
  const { toast } = useToast()
  const { isSupport } = useAuth()

  const [selectedStatus, setSelectedStatus] = useState<
    'PAGO' | 'NAO_PAGO' | null
  >(null)

  const { mutateAsync: approveWithdraw, isPending: approving } = useMutation({
    mutationFn: (id: string) => WithdrawService.ApproveWithdraw(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['withdraws'] })
      queryClient.invalidateQueries({
        queryKey: ['getAvailvableAmount'],
      })
      toast({ title: 'Transferência aprovada com sucesso!' })
    },
    onError: () => {
      toast({
        title: 'Erro ao aprovar a transferência',
        variant: 'destructive',
      })
    },
  })

  const { mutateAsync: refuseWithdraw, isPending: refusing } = useMutation({
    mutationFn: (id: string) => WithdrawService.RefuseWithdraw(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['withdraws'] })
      queryClient.invalidateQueries({
        queryKey: ['getAvailvableAmount'],
      })
      toast({ title: 'Transferência recusada com sucesso!' })
    },
    onError: () => {
      toast({
        title: 'Erro ao recusar a transferência',
        variant: 'destructive',
      })
    },
  })

  return {
    selectedStatus,
    setSelectedStatus,
    approveWithdraw,
    refuseWithdraw,
    approving,
    refusing,
    // O suporte enxerga o erro da atualização, mas não pode sobrescrever o
    // status do saque manualmente (aprovar/recusar é @OnlySuper na API).
    canChangeStatus: !isSupport,
  }
}
